import React from "react";
import { useFormContext } from "react-hook-form";
import { Box, Typography } from "@material-ui/core";
import { RadioSelector, DropdownSelector } from "../../../components/Forms";

export interface ContactTypeProps {
  defaultValue?: string;
  types: { name: string; value: string }[];
  onChange?: (id: string) => void;
}

export const ContactType: React.FC<ContactTypeProps> = ({
  types,
  onChange,
  defaultValue,
}) => {
  const { errors } = useFormContext() || {};

  return (
    <Box>
      {types.length < 5 ? (
        <>
          <Typography variant="body1">Contact Type</Typography>
          <RadioSelector
            name="type"
            options={types}
            onChange={onChange}
            radioProps={{
              "data-testid": "ContactType__RadioGroup",
            }}
            controllerProps={{ defaultValue }}
          />
        </>
      ) : (
        <Box width={260}>
          <DropdownSelector
            name="type"
            options={types}
            onChange={onChange}
            controllerProps={{ defaultValue }}
            fieldProps={{
              label: "Contact Type",
              fullWidth: true,
              "data-testid": "ContactType__TextField--Select",
              error: !!errors?.type,
              helperText: errors?.type?.message,
            }}
          />
        </Box>
      )}
    </Box>
  );
};
